import {
    PaymentCheckoutRequest,
} from '@lib/domain/payment/checkout';
import { HTTPService } from '../HTTPService/HTTPService';
import { APP_CONFIG } from '@lib/constants';

interface Dependencies {
    httpService: HTTPService;
}

export class CheckoutService {
    private httpService: HTTPService;

    constructor({ httpService }: Dependencies) {
        this.httpService = httpService;
    }

    async payment(payload: PaymentCheckoutRequest) {
        const url = '/api/checkout/payment-request';
        const res = await this.httpService.post({
            url,
            data: payload,
            options : {
                baseURL: APP_CONFIG.SITE_URL
            }
        });
        return res.data;
    }

    async checkPaymentStatusBySession(sessionId: string): Promise<string> {
        const res = await this.httpService.post({
             url: `/api/checkout/payment-detail`,
            data: {sessionId},
            options : {
                baseURL: APP_CONFIG.SITE_URL
            }
        }
           
        )

        const data = res.data
        return data
    }
}
